import axios from 'axios'
import {AuthModel, UserModel} from './_models'
import {API_URL} from '../../../tenant/apiBase'

// Common headers used across requests
const COMMON_HEADERS = {
  Authorization: 'Basic ZHVteWFoX3N0YWdpbmc6MjAxNUR1bXlhaEAxQDNAU3RhZ2luZw==',
}

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/api/partner-portal/user/info`
export const LOGIN_URL = `${API_URL}/api/partner-portal/login`
export const LOGOUT_URL = `${API_URL}/api/partner-portal/user/logout`
export const REGISTER_URL = `${API_URL}/register`
export const REQUEST_PASSWORD_URL = `${API_URL}/api/partner-portal/send-forgot-password-code`
export const VERIFY_OTP_URL = `${API_URL}/api/partner-portal/verify-forgot-password`
export const UPDATE_PASSWORD_URL = `${API_URL}/api/partner-portal/update-forgot-password`
export const CHANGE_LANGUAGE = `${API_URL}/api/partner-portal/user/language`
// Export the changeLanguage function explicitly
// Server should return AuthModel
export function login(email: string, password: string, language: string) {
  return axios.post<AuthModel>(
    LOGIN_URL,
    {
      email,
      password,
    },
    {
      headers: {
        ...COMMON_HEADERS,
        'Accept-Language': language,
        language: language,
      },
    }
  )
}

export function changeLanguage(token: string, language: string) {
  return axios.put<any>(
    `${CHANGE_LANGUAGE}`,
    {language},
    {
      headers: {
        ...COMMON_HEADERS,
        token: token,
      },
    }
  )
}

// Server should return AuthModel
export function register(
  email: string,
  firstname: string,
  lastname: string,
  password: string,
  password_confirmation: string
) {
  return axios.post(REGISTER_URL, {
    email,
    first_name: firstname,
    last_name: lastname,
    password,
    password_confirmation,
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string, language: string) {
  return axios.post<{
    status_code: string
    message: string
    expires_in: number
    expires_at: number
    attempts_remaining: number
  }>(
    REQUEST_PASSWORD_URL,
    {
      email,
    },
    {
      headers: {
        ...COMMON_HEADERS,
        'Accept-Language': language,
        language: language,
      },
    }
  )
}

export function verifyOTP(email: string, code: string, language: string) {
  return axios.post<{
    status_code: string
    user: {
      name: string
      supplier_name: string
      email: string
      supplier_id: number
      supplier_user_id: number
      token: string
      payment_terms: string
      margin: number
    }
  }>(
    VERIFY_OTP_URL,
    {
      email,
      code,
    },
    {
      headers: {
        ...COMMON_HEADERS,
        'Accept-Language': language,
        language: language,
      },
    }
  )
}

export function updatePassword(token: string, password: string, confirm: string) {
  return axios.post<{
    status_code: string
    message: string
  }>(
    UPDATE_PASSWORD_URL,
    {
      password,
      confirm,
    },
    {
      headers: {
        ...COMMON_HEADERS,
        token: token,
      },
    }
  )
}

export function getUserByToken(token: string) {
  return axios.get<UserModel>(`${GET_USER_BY_ACCESSTOKEN_URL}?token=${token}`, {
    headers: {token: token},
  })
}

export function doLogout(token: string) {
  return axios.post<any>(
    LOGOUT_URL,
    {},
    {
      headers: {
        ...COMMON_HEADERS,
        token: token,
      },
    }
  )
}
